import type { FC } from 'react';
import { Label } from '../atoms/label.component';
import { FloatingLabelStyles } from './floating-label.styles';
import { FloatingLabelProps } from './types';

export const FloatingLabel: FC<React.PropsWithChildren<FloatingLabelProps>> = ({
  active,
  children,
  disabled,
  hasError,
  leftOffset = 0,
  ...rest
}) => {
  const styles = FloatingLabelStyles.floatingLabel({ disabled, hasError, leftOffset, active });
  return (
    <Label css={styles} {...rest}>
      {children}
    </Label>
  );
};
